import { styled } from "styled-components";
import { colors, devices } from "../../utils/styled/_variables.styled";

export const ModalFiller = styled.div`
  .modal__out {
    position: fixed;
    width: 100vw;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    z-index: 1200;
    border-radius: 8px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    overflow: hidden;

    @media ${devices.desktop} {
      height: 70vh;
      width: 750px;
      margin: auto auto;
    }
  }
`;

export const AntiModal = styled.div`
  visibility: visible;
  display: flex;
  width: 100vw;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1100;
`;

export const ModalContent = styled.div`
  position: absolute;
  overflow-y: auto;
  width: 100vw;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  z-index: 1200;
  scroll-behavior: smooth;
  background: ${colors.white};
  padding: 24px 24px 140px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  
  @media (min-width: 768px) {
    height: 70vh;
    width: 750px;
    margin: auto auto;
    border-radius: 8px;
    padding: 24px;
  }

  .modal__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .modal__header.hideArrow {
    justify-content: flex-end;
  }

  .modal__title {
    font-size: 24px;
    font-weight: 700;
    text-transform: unset;
    line-height: 36px;
    color: ${colors.gray1};
    padding-bottom: 12px;
  }

  .modal__subtitle {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: ${colors.gray2};
  }
  .modal__text {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: ${colors.gray2};
    padding-top: 12px;
  }
`;

export const CloseButton = styled.button`
  cursor: pointer;
  border: none;
  background: transparent;
`;

export const ArrowButton = styled.button`
  cursor: pointer;
  border: none;
  background: transparent;
`;
